import * as hfMap from "./index.js";

window.HfMap = hfMap;
Object.assign(window, hfMap);
